import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const tripVideoService = {
  async deleteAsync(tripVideoId) {
    const response = await apiClient.delete(
      `${endPoints.tripVideo.delete}/${tripVideoId}`,
    );
    return response.data;
  },
  async createAsync(tripId, data) {
    const response = await apiClient.post(
      `${endPoints.tripVideo.create}/${tripId}`,
      data
    );
    return response.data;
  },
};